<template>
  <div v-if="isAdmin" class="playground panel-admin-body">
    <div class="title d-none">
      <div class="d-flex">
        {{ title }}
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-4"> 
         <div class="d-flex">
          <div class="summernote-container">
            <input
              type="text"
              v-model="chartName"
              @input="getGrokSuggestions(chartName)"
              placeholder="Enter chart name"
            />

            <ul class="suggestions-dropdown" v-if="suggestions.length > 0">
              <li
                v-for="suggestion in suggestions"
                :key="suggestion"
                @click="selectSuggestion(suggestion)"
              >
                {{ suggestion }}
              </li>
            </ul>
          </div>
         </div>  
      </div>
    </div>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>
<script>
import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";
import DataTableMixins from "../mixins/DataTableMixins.vue";

import AdminService from "../services/admin.service";
import SurveyService from "../services/survey.service";
import ErrorService from "../services/error.service";
import SurveySummaryService from "../services/survey.summary.service";

import $ from "jquery";
import 'summernote';
import axios from 'axios';
const BASE_URL = process.env.VUE_APP_BASE_URL;
export default {
  name: "Playground",
  mixins: [AdminMixins, ViewMixins, DataTableMixins],
  components: {},
  props: {},
  data() {
    return {
      title: "At the Playground",
      suggestions: [],
      chartName: '',
      
      API_URL: BASE_URL + "/api/v1/grok/",
    };
  },
  methods: {
    async getGrokSuggestions(query) {
      if(query.trim() == "") {
        this.suggestions = [];
      }
      axios
        .get(this.API_URL + "get-grok-suggestions", { params: { query } })
        .then((response) => {
          this.suggestions = response.data;
        })
        .catch((error) => {
          //console.error('Error fetching suggestions:', error);
        });
      
    },
    selectSuggestion(suggestion) {
      this.chartName = suggestion; // update input box
      this.suggestions = []; // hide dropdown
    }
  },
  created() {},
  mounted() {
    $('#summernote').summernote({
      // Summernote configuration options
      height: 250,
      callbacks: {
        onChange: (contents, $editable) => {
          this.getGrokSuggestions(contents); // Trigger API call on change
        }
      }
    });
  }
};
</script>
<style scoped>
.chartname-container {
  position: relative;
  width: 200px;
}

.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 10;
  width: auto;
  z-index: 100;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  background-color: #fff;
}

.suggestions-dropdown li {
  padding: 8px;
  cursor: pointer;
}

.suggestions-dropdown li:hover {
  background-color: #f0f0f0;
}
</style>
